// @noflow
import React from 'react'
import { animated, useTransition } from 'react-spring'

import Card from '@/components/elements/atoms/Card/Card'

import STYLES from './CardCallout.module.sass'

type Props = {
  show: boolean
  children: React.JSX.Element
}

const CardCallout = ({ show, children }: Props): React.JSX.Element => {
  const cardTransitions = useTransition(show, {
    from: { opacity: 0, transform: 'translateY(-10px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(-10px)' },
    config: { duration: 200 }
  })

  return cardTransitions(
    (style, show) =>
      show && (
        <animated.div style={style}>
          <div
            className={STYLES.triangle}
            role="presentation"
            aria-label="triangle"
          />
          <Card padding={24}>{children}</Card>
        </animated.div>
      )
  )
}

export { CardCallout }
